import React, { useState } from 'react';
import ContentLoader from 'react-content-loader';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  fill?: boolean;
  quality?: number;
  objectPosition?: string;
  width?: number | string;
  height?: number | string;
}

export default function Image(
  props: ImageProps & { showLoader?: boolean; fallbackImage?: string },
) {
  const [loaded, setLoaded] = useState(false);
  const [imageNotFound, setImageNotFound] = useState(false);

  const shouldShowLoader =
    props.showLoader === undefined ? true : props.showLoader;

  const placeholder = props.fallbackImage ?? '/assets/images/logo.png';
  const imgProps = { ...props };
  delete imgProps.showLoader;
  delete imgProps.fallbackImage;

  return (
    <div
      style={{
        display: 'flex',
        placeContent: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      {shouldShowLoader && !loaded && (
        <div style={{ width: 80, height: 80, flex: '1', objectFit: 'contain' }}>
          <ContentLoader
            speed={2}
            width="100%"
            height="100%"
            // viewBox="0 0 226 320"
            backgroundColor="#F3F6FA"
            foregroundColor="#E7ECF3"
            className="w-full h-auto shadow-card rounded-md overflow-hidden"
          >
            <rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
          </ContentLoader>
        </div>
      )}
      <img
        {...imgProps}
        onLoad={() => setLoaded(true)}
        loading="lazy"
        src={
          imageNotFound
            ? placeholder
            : ((imgProps.src as string) ?? placeholder)
        }
        style={{
          ...imgProps.style,
          flex: '1',
          objectFit:
            imgProps.className?.includes('object-cover') || imgProps.fill
              ? 'cover'
              : 'contain',
        }}
        onError={() => {
          setImageNotFound(true);
        }}
        alt={''}
      />
    </div>
  );
}
